// extracted by mini-css-extract-plugin
export default {"customOption":"styles_customOption__80FPE","title":"styles_title__f65FA","optionTitle":"styles_optionTitle__pcJET"};